import { render, staticRenderFns } from "./shortcutBtn.vue?vue&type=template&id=f680210a&scoped=true"
import script from "./shortcutBtn.vue?vue&type=script&lang=js"
export * from "./shortcutBtn.vue?vue&type=script&lang=js"
import style0 from "./shortcutBtn.vue?vue&type=style&index=0&id=f680210a&prod&lang=less&scoped=true"
import style1 from "./shortcutBtn.vue?vue&type=style&index=1&id=f680210a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f680210a",
  null
  
)

export default component.exports